import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { Box } from "@mui/material";
import {
  createIptvChannel,
  getAllChannelCategory,
  getAllChannelLanguage,
  updateIptvChannel,
} from "../../Components/service/admin";
import { loader, snackbar } from "../../utils";
import EditIcon from "@mui/icons-material/Edit";
import CustomDrawer from "../../Components/CustomDrawer/CustomDrawer";

export const AddIptvChannel = ({ onSubmit, mode, formData }) => {
  const [drawer, setDrawer] = useState(false);
  const [categories, setCategories] = useState([]);
  // const [languages, setLanguages] = useState([]);

  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      name: "",
      channelCategory: "",
      lcnNo: "",
      priority: 0,
      image: null,
      // language: "",
    },
  });

  // Fetch channel categories
  async function getCategories() {
    try {
      loader.start();
      let res = await getAllChannelCategory();
      setCategories(res?.data?.data || []);
    } catch (error) {
      console.log(error);
      snackbar.error("Failed to fetch categories");
    } finally {
      loader.stop();
    }
  }

  // async function getAllLangauge() {
  //   try {
  //     loader.start();
  //     let res = await getAllChannelLanguage();
  //     setLanguages(res?.data?.data || []);
  //   } catch (error) {
  //     console.log(error);
  //     snackbar.error("Failed to fetch languages");
  //   } finally {
  //     loader.start();
  //   }
  // }

  useEffect(() => {
    getCategories();
    // getAllLangauge();
  }, []);

  async function formSubmit(data) {
    try {
      loader.start();

      // Create FormData object
      const formDataObj = new FormData();
      formDataObj.append("name", data.name);
      formDataObj.append("channelCategory", data.channelCategory);
      formDataObj.append("lcnNo", data.lcnNo);
      formDataObj.append("priority", data.priority || 0);
      // formDataObj.append("language", data.language);

      // Append image file if selected
      if (data.image) {
        formDataObj.append("image", data.image);
      }

      if (mode === "edit") {
        await updateIptvChannel(formData._id, formDataObj);
        snackbar.success("IPTV Channel updated successfully");
      } else {
        await createIptvChannel(formDataObj);
        snackbar.success("IPTV Channel created successfully");
      }

      onSubmit();
      reset();
      setDrawer(false);
    } catch (error) {
      console.log(error);
      snackbar.error("Operation failed");
    } finally {
      loader.stop();
    }
  }

  function editClick() {
    if (formData) {
      reset({
        name: formData.name || "",
        channelCategory: formData.channelCategory?._id || "",
        lcnNo: formData.lcnNo || "",
        priority: formData.priority || 0,
        image: null, // Reset image for edit mode
        // language: formData.language,
      });
    }
    setDrawer(true);
  }

  return (
    <div>
      {mode === "edit" ? (
        <EditIcon className="pointer" onClick={editClick} />
      ) : (
        <button
          className="btn btn-primary btn-radius px-3"
          onClick={() => setDrawer(true)}
        >
          Add IPTV Channel
        </button>
      )}

      <CustomDrawer
        width={600}
        open={drawer}
        toggle={() => setDrawer(!drawer)}
        header={`${mode === "edit" ? "Edit" : "Add"} IPTV Channel`}
      >
        <Box mt={3}>
          <form onSubmit={handleSubmit(formSubmit)}>
            {/* Channel Name */}
            <div className="mb-3">
              <label className="form-label mb-1" htmlFor="name">
                Channel Name *
              </label>
              <Controller
                name="name"
                control={control}
                rules={{
                  required: "Channel name is required",
                  validate: (value) =>
                    value.trim() !== "" || "Field cannot be empty",
                }}
                render={({ field: { value, onChange } }) => (
                  <input
                    value={value}
                    onChange={onChange}
                    className={`form-control ${
                      errors.name ? "is-invalid" : ""
                    }`}
                    placeholder="Enter channel name"
                  />
                )}
              />
              {errors.name && (
                <div className="invalid-feedback">{errors.name.message}</div>
              )}
            </div>

            {/* Channel Category */}
            <div className="mb-3">
              <label className="form-label mb-1" htmlFor="channelCategory">
                Channel Category *
              </label>
              <Controller
                name="channelCategory"
                control={control}
                rules={{ required: "Channel category is required" }}
                render={({ field: { value, onChange } }) => (
                  <select
                    className={`form-select ${
                      errors.channelCategory ? "is-invalid" : ""
                    }`}
                    value={value}
                    onChange={onChange}
                  >
                    <option value="">Select Channel Category</option>
                    {categories.map((category) => (
                      <option value={category._id} key={category._id}>
                        {category.name}
                      </option>
                    ))}
                  </select>
                )}
              />
              {errors.channelCategory && (
                <div className="invalid-feedback">
                  {errors.channelCategory.message}
                </div>
              )}
            </div>

            {/* Channel Language */}
            {/* <div className="mb-3">
              <label className="form-label mb-1" htmlFor="channelLanguage">
                Channel language *
              </label>
              <Controller
                name="channelLanguage"
                control={control}
                rules={{ required: "Channel language is required" }}
                render={({ field: { value, onChange } }) => (
                  <select
                    className={`form-select ${
                      errors.channelLanguage ? "is-invalid" : ""
                    }`}
                    value={value}
                    onChange={onChange}
                  >
                    <option value="">Select Channel Language</option>
                    {languages.map((language) => (
                      <option value={language._id} key={language._id}>
                        {language.name}
                      </option>
                    ))}
                  </select>
                )}
              />
              {errors.channelLanguage && (
                <div className="invalid-feedback">
                  {errors.channelLanguage.message}
                </div>
              )}
            </div> */}

            {/* LCN Number */}
            <div className="mb-3">
              <label className="form-label mb-1" htmlFor="lcnNo">
                LCN Number *
              </label>
              <Controller
                name="lcnNo"
                control={control}
                rules={{
                  required: "LCN number is required",
                  pattern: {
                    value: /^[0-9]+$/,
                    message: "LCN number must be numeric",
                  },
                }}
                render={({ field: { value, onChange } }) => (
                  <input
                    value={value}
                    onChange={onChange}
                    type="number"
                    className={`form-control ${
                      errors.lcnNo ? "is-invalid" : ""
                    }`}
                    placeholder="Enter LCN number"
                  />
                )}
              />
              {errors.lcnNo && (
                <div className="invalid-feedback">{errors.lcnNo.message}</div>
              )}
              <small className="form-text text-muted">
                Logical Channel Number for channel ordering
              </small>
            </div>

            {/* Priority */}
            <div className="mb-3">
              <label className="form-label mb-1" htmlFor="priority">
                Priority
              </label>
              <Controller
                name="priority"
                control={control}
                render={({ field: { value, onChange } }) => (
                  <input
                    value={value}
                    onChange={onChange}
                    type="number"
                    min="0"
                    className="form-control"
                    placeholder="0"
                  />
                )}
              />
              <small className="form-text text-muted">
                Channel priority (default: 0)
              </small>
            </div>

            {/* Image Upload */}
            <div className="mb-3">
              <label className="form-label mb-1" htmlFor="image">
                Channel Image {mode !== "edit" && "*"}
              </label>
              <Controller
                name="image"
                control={control}
                rules={mode !== "edit" ? { required: "Image is required" } : {}}
                render={({ field: { onChange } }) => (
                  <input
                    type="file"
                    accept="image/*"
                    id="image"
                    onChange={(e) => onChange(e.target.files[0])}
                    className={`form-control ${
                      errors.image ? "is-invalid" : ""
                    }`}
                  />
                )}
              />
              {errors.image && (
                <div className="invalid-feedback">{errors.image.message}</div>
              )}
              <small className="form-text text-muted">
                Upload channel logo/image (JPG, PNG, GIF)
              </small>
            </div>

            {/* Action Buttons */}
            <div className="d-flex justify-content-end mt-4">
              <button
                className="btn btn-secondary me-2"
                type="button"
                onClick={() => setDrawer(false)}
              >
                Cancel
              </button>
              <button className="btn btn-primary" type="submit">
                {mode === "edit" ? "Update" : "Add"} Channel
              </button>
            </div>
          </form>
        </Box>
      </CustomDrawer>
    </div>
  );
};
